import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectTotalCount = (store: StoreSchema) =>
	store.instanceEvents.paginatedInstanceEvents.totalCount
